<template>
  <div>
    <v-card
      v-for="(client, clientIndex) in tempClients"
      v-bind:key="'client-' + clientIndex"
      class="mt-5"
    >
      <v-card-actions>
        <h1 class="ml-3">{{ $t("CLIENT") }}: {{ client.clientName }}</h1>
        <v-spacer></v-spacer>
        <ModalAddToInvoice
          :client="client"
          :type="type"
          :documentType="documentType"
          :source="source"
          @addedToInvoice="addedToInvoice($event, client.clientId)"
        ></ModalAddToInvoice>
      </v-card-actions>
      <div>
        <TableActionsForInvoice
          v-if="_.size(client.wholesales) > 0"
          :actions="client.wholesales"
          :header="$t('WHOLESALES')"
        ></TableActionsForInvoice>
        <TableActionsForInvoice
          v-if="_.size(client.wholesaleReturnings) > 0"
          :actions="client.wholesaleReturnings"
          :header="$t('STOCK_CLIENT_RETURNING')"
        ></TableActionsForInvoice>
      </div>
    </v-card>
  </div>
</template>
<script>
import ModalAddToInvoice from "@/modules/stock/components/actions/stockList/ModalAddToInvoice.vue";
import TableActionsForInvoice from "@/modules/stock/components/actions/stockList/TableActionsForInvoice.vue";
import _ from "lodash";
export default {
  name: "WrapperClientsForInvoice",
  inheritAttrs: false,
  props: {
    clients: {
      type: Array,
      default: function() {
        return [];
      }
    },
    type: {
      type: String,
      default: function() {
        return "outgoing";
      }
    },
    documentType: {
      type: String,
      default: function() {
        return "invoice";
      }
    }
  },
  data() {
    return {
      source: "client",
      search: "",
      docTotalWithVatCurrency: ""
    };
  },
  components: {
    ModalAddToInvoice,
    TableActionsForInvoice
  },
  computed: {
    tempClients: {
      get: function() {
        return this.clients;
      },
      set: function(newValue) {
        this.$emit("update:clients", newValue);
      }
    }
  },
  methods: {
    addedToInvoice(params, clientId) {
      //Splice-ваме ги в парент компонента
      let args = {
        ...params,
        clientId: clientId
      };
      this.$emit("addedToInvoice", args);
    }
  }
};
</script>
